import { baseState, baseMutations } from '@/store/mixins'
import httpClient from '@/http-client'
import moment from 'moment'

const BASE_URL = '/api/receipts'

export default {
	namespaced: true,
	state: {
		...baseState,
		date_from: moment().format('DD-MM-YYYY'),
		date_to: moment().format('DD-MM-YYYY')
	},
	mutations: {
		...baseMutations,
		SET_DATE_FROM(state, date) {
			state.date_from = date
		},
		SET_DATE_TO(state, date) {
			state.date_to = date
		}
	},
	actions: {
		onFetch(context, attrubutes = {}) {
			let params = Object.assign(
				{
					date_from: context.state.date_from,
					date_to: context.state.date_to,
				},
				attrubutes
			)
			return httpClient.get(`${BASE_URL}`, {
				params
			})
		},
		onSave(context, data) {
			return httpClient.post(`${BASE_URL}`, data)
		},
		onPreviewPdf(context, { id }) {
			return httpClient.get(`${BASE_URL}/${id}/preview-pdfs`)
		},
		onGetInvoice(context, params = {}) {
			return httpClient.get(`${BASE_URL}/invoice-lists`, {
				params
			})
		},
		onGetBank(context, params = {}) {
			return httpClient.get(`${BASE_URL}/banks`, {
				params
			})
		},
		onGetExchange(context, params = {}) {
			return httpClient.get(`${BASE_URL}/exchange-rates`, {
				params
			})
		}
	}
}
